import { t } from '@trimble/i18n';
import { JSX } from 'solid-js';

export function StationsLoadingIndicator(): JSX.Element {
  return (
    <div
      class="absolute bottom-4 left-1/2 -translate-x-1/2 z-dropdown flex flex-col items-center gap-1 px-4 py-2 rounded w-[300px] bg-base-300"
      data-testid="image-loading-progress-bar"
    >
      {/* eslint-disable-next-line custom/no-modus-v1 -- TWENG-132 */}
      <modus-progress-bar
        mode="indeterminate"
        size="compact"
        aria-label="Loading stations"
        class="w-full"
      />
      <span class="text-sm text-base-content">
        {t('mobileMapping.stations.loading')}
      </span>
    </div>
  );
}
